import { Component, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { NxDialogService, NxModalRef } from '@aposin/ng-aquila/modal';
import { CommonService } from '@core/services/common.service';

@Component({
    selector: 'app-payment-method-popup',
    templateUrl: './payment-method-popup.component.html',
    styleUrls: ['./payment-method-popup.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PaymentMethodPopupComponent implements OnInit {
  // modal
  @ViewChild('popupPayment')
  templateRefPayment: TemplateRef<any>;

  @ViewChild('popupVehicle2')
  templateRefVehicle: TemplateRef<any>;

  templateDialogRef: NxModalRef<any>;

  constructor(
    private commonService: CommonService,
    private dialogService: NxDialogService
  ) { }

  ngOnInit(): void {
    if (this.commonService.EditPopUpOpenModalSubscription === undefined) {
      this.commonService.EditPopUpOpenModalSubscription = this.commonService.EditPopUpOpenModalFunction.subscribe(
        (type) => { this.openModal(type); });
    }
  }

  openModal(type){
    if(type == 'vehicle'){
      this.templateDialogRef = this.dialogService.open(this.templateRefVehicle, { showCloseIcon: true });
    }
    if(type == 'payment'){
      this.templateDialogRef = this.dialogService.open(this.templateRefPayment, { showCloseIcon: true });
    }
  }

}
